import styled from 'styled-components';

export const Container = styled.p`
  margin: 0;
`;
